export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      {/* Upper Footer */}
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          {/* Brand Column */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <img 
                src="https://public.readdy.ai/ai/img_res/34881ac6-ae26-405c-ab79-330b641503fe.png" 
                alt="Restaurant Logo" 
                className="h-10 w-auto brightness-0 invert"
              />
            </div>
            <p className="text-gray-400 text-sm mb-6 leading-relaxed">
              Fresh ingredients, family tradition, and unforgettable flavors.
            </p>
            <div className="flex gap-2">
              <input 
                type="email" 
                placeholder="Your email"
                className="flex-1 px-4 py-2 bg-gray-800 border border-gray-700 rounded-full text-sm focus:outline-none focus:border-red-700 transition-colors"
              />
              <button className="w-10 h-10 flex items-center justify-center bg-red-700 rounded-full hover:bg-red-800 transition-colors cursor-pointer">
                <i className="ri-mail-line"></i>
              </button>
            </div>
          </div>

          {/* Menu Links */}
          <div>
            <h3 className="text-lg font-bold mb-4">Menu</h3>
            <ul className="space-y-2">
              <li><a href="#menu" className="text-gray-400 hover:text-white transition-colors text-sm cursor-pointer">Appetizers</a></li>
              <li><a href="#menu" className="text-gray-400 hover:text-white transition-colors text-sm cursor-pointer">Main Dishes</a></li>
              <li><a href="#menu" className="text-gray-400 hover:text-white transition-colors text-sm cursor-pointer">Desserts</a></li>
              <li><a href="#menu" className="text-gray-400 hover:text-white transition-colors text-sm cursor-pointer">Drinks</a></li>
            </ul>
          </div>

          {/* Information Links */}
          <div>
            <h3 className="text-lg font-bold mb-4">About</h3>
            <ul className="space-y-2">
              <li><a href="#about" className="text-gray-400 hover:text-white transition-colors text-sm cursor-pointer">Our Story</a></li>
              <li><a href="#contact" className="text-gray-400 hover:text-white transition-colors text-sm cursor-pointer">Catering</a></li>
              <li><a href="#contact" className="text-gray-400 hover:text-white transition-colors text-sm cursor-pointer">Events</a></li>
              <li><a href="#contact" className="text-gray-400 hover:text-white transition-colors text-sm cursor-pointer">Careers</a></li>
            </ul>
          </div>

          {/* Contact Column */}
          <div>
            <h3 className="text-lg font-bold mb-4">Visit Us</h3>
            <ul className="space-y-3 text-sm">
              <li className="text-gray-400 leading-relaxed">
                123 Culinary Street<br />
                Downtown District<br />
                New York, NY 10001
              </li>
              <li>
                <a href="tel:+15551234567" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  (555) 123-4567
                </a>
              </li>
              <li>
                <a href="mailto:info@restaurant.com" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  info@restaurant.com
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Lower Footer */}
      <div className="border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-6 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-sm text-gray-400">
              © 2024 Restaurant. All rights reserved.
            </p>
            
            <div className="flex items-center gap-6">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center border border-gray-700 rounded-lg text-gray-400 hover:text-white hover:border-red-700 transition-all cursor-pointer">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center border border-gray-700 rounded-lg text-gray-400 hover:text-white hover:border-red-700 transition-all cursor-pointer">
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center border border-gray-700 rounded-lg text-gray-400 hover:text-white hover:border-red-700 transition-all cursor-pointer">
                <i className="ri-twitter-x-line text-lg"></i>
              </a>
              <a href="https://tripadvisor.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center border border-gray-700 rounded-lg text-gray-400 hover:text-white hover:border-red-700 transition-all cursor-pointer">
                <i className="ri-map-pin-user-line text-lg"></i>
              </a>
            </div>

            <div className="flex items-center gap-4 text-sm">
              <a href="#privacy" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Privacy Policy</a>
              <span className="text-gray-700">|</span>
              <a href="#terms" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Terms</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}